import { gql } from '@apollo/client';

export const GET_PEOPLE = gql`
  query GetPeople {
    people(
      filters: {
        permission_key: "core.people.inspector"
        active: "true"
      }
    ) {
      list {
        id
        name
      }
    }
  }
`;
